module.exports = __webpack_public_path__ + "img/minus.e0c35b7f.svg";